import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import {
  handleNavScroll,
  handleClickOutside,
  handleLogout
} from "../../utils/custom";
import { getFullFileUrl } from "../../Helpers/UrlHelpers";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faSignOutAlt,
  faBook,
  faGraduationCap,
  faFileAlt,
  faUserGraduate,
  faBookOpen,
  faDashboard,
  faCheck,
  faChevronUp,
  faChevronDown,
  faLock,
  faUserPlus,
  faChalkboardTeacher,
  faTrophy
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
import { storageHelper } from '../../Helpers/storageHelper';
import { Link as RouterLink } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import Divider from '@mui/material/Divider';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import wordmarkSrc from '../../assets/images/word_mini.svg';
import RamdanUI from './RamdanUI';

const Header = () => {
  const [user, setUser] = useState(null);
  const [userType, setUserType] = useState(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [userImage, setUserImage] = useState(null);
  const dropdownRef = useRef(null);
  const desktopHeaderRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSection, setActiveSection] = useState('top');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [logoutLoading, setLogoutLoading] = useState(false);
  const [isRegisterDropdownOpen, setIsRegisterDropdownOpen] = useState(false);
  const registerDropdownRef = useRef(null);
  const [isServicesDropdownOpen, setIsServicesDropdownOpen] = useState(false);
  const servicesDropdownRef = useRef(null);
  const [isHomeDropdownOpen, setIsHomeDropdownOpen] = useState(false);
  const homeDropdownRef = useRef(null);
  const cairoFont = 'Zain, sans-serif';

  const homeMenuItems = [
    {
      key: 'hero',
      label: 'الرئيسية',
      description: 'العودة لأعلى الصفحة',
      icon: faGraduationCap,
      href: '/'
    },
    {
      key: 'events',
      label: 'الفعاليات',
      description: 'تابع أحدث الفعاليات والأحداث',
      icon: faTrophy,
      href: '#events'
    },
    {
      key: 'about',
      label: 'من نحن',
      description: 'تعرّف على رؤية امتحاني',
      icon: faUser,
      to: '/about'
    },
    {
      key: 'news',
      label: 'اخر الاخبار',
      description: 'استكشف أحدث المقالات والمدونات',
      icon: faFileAlt,
      to: '/blogs'
    }
  ];

  const servicesMenuItems = [
    {
      key: 'services',
      label: 'الخدمات',
      description: 'حلول متكاملة للطلاب والمعلمين',
      icon: faBook,
      to: '/services'
    },
    {
      key: 'teachers',
      label: 'معلمينا',
      description: 'خبرات تعليمية موثوقة',
      icon: faChalkboardTeacher,
      to: '/teachers'
    },
    {
      key: 'courses',
      label: 'الدورات التعليمية',
      description: 'محتوى تفاعلي متجدد',
      icon: faBookOpen,
      to: '/courses'
    }
  ];

  const registerMenuItems = [
    {
      key: 'student-register',
      label: 'تسجيل حساب طلاب',
      description: 'انضم إلى مجتمع المتعلمين',
      icon: faUserGraduate,
      href: '#contact'
    },
    {
      key: 'teacher-register',
      label: 'تسجيل حساب معلمين',
      description: 'شارك خبرتك مع طلابنا',
      icon: faChalkboardTeacher,
      to: '/register-teacher'
    }
  ];

  const navQuickLinks = [
    {
      key: 'pricing',
      label: 'الباقات والأسعار',
      to: '/pricing',
      icon: faBookOpen
    },
    {
      key: 'honor-board',
      label: 'لوحة الشرف',
      to: '/honor-board',
      icon: faTrophy
    },
    {
      key: 'teacher-documentation',
      label: 'دليل المعلم',
      to: '/teacher-documentation',
      icon: faBook
    }
  ];

  const homeActiveSections = ['top', 'services', 'courses', 'our-teachers'];
  const homeIsActive = homeActiveSections.includes(activeSection);

  // Close dropdown when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (registerDropdownRef.current && !registerDropdownRef.current.contains(event.target)) {
        setIsRegisterDropdownOpen(false);
      }
      if (servicesDropdownRef.current && !servicesDropdownRef.current.contains(event.target)) {
        setIsServicesDropdownOpen(false);
      }
      if (homeDropdownRef.current && !homeDropdownRef.current.contains(event.target)) {
        setIsHomeDropdownOpen(false);
      }
    }
    if (isRegisterDropdownOpen || isServicesDropdownOpen || isHomeDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isRegisterDropdownOpen, isServicesDropdownOpen, isHomeDropdownOpen]);

  const handleDrawerOpen = () => setDrawerOpen(true);
  const handleDrawerClose = () => setDrawerOpen(false);


  useEffect(() => {
    const full_name = storageHelper.getItem("full_name");
    const user_type = storageHelper.getItem("user_type");
    const user_image = storageHelper.getItem("user_image");
    if (full_name) {
      setUser(full_name);
    }
    if (user_type) {
      setUserType(user_type);
    }
    if (user_image) {
      setUserImage(user_image);
    }

    // Add event listeners
    window.addEventListener('scroll', handleNavScroll);

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleNavScroll);
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (isMobile) {
      return undefined;
    }

    const updateHeaderBackground = () => {
      if (!desktopHeaderRef.current) return;
      if (window.scrollY > 80) {
        desktopHeaderRef.current.classList.add('background-header');
      } else {
        desktopHeaderRef.current.classList.remove('background-header');
      }
    };

    updateHeaderBackground();
    window.addEventListener('scroll', updateHeaderBackground);

    return () => {
      window.removeEventListener('scroll', updateHeaderBackground);
      desktopHeaderRef.current?.classList.remove('background-header');
    };
  }, [isMobile]);

  // Scroll spy for section links
  useEffect(() => {
    const handleScrollSpy = () => {
      const sections = [
        { id: 'top', label: 'الرئيسية' },
        { id: 'services', label: 'الخدمات' },
        { id: 'courses', label: 'الدورات التعليمية' },
        { id: 'our-teachers', label: 'معلمينا' }
      ];
      let found = 'top';
      for (const section of sections) {
        const el = document.getElementById(section.id);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 80) {
            found = section.id;
          }
        }
      }
      setActiveSection(found);
    };
    window.addEventListener('scroll', handleScrollSpy);
    return () => window.removeEventListener('scroll', handleScrollSpy);
  }, []);

  const getProfileLink = () => {
    const userType = storageHelper.getItem('user_type');
    if (userType === 'Teacher') {
      return '/teacher/dashboard?tab=profile';
    }
    return '/student/profile';
  };

  const getDropdownLabel = () => {
    if (userType === 'superadmin' || userType === 'SuperAdmin') return 'قائمة الأدمن';
    if (userType === 'Teacher') return 'قائمة المعلم';
    return 'قائمة المستخدم';
  };

  const renderMenuContent = (items, closeMenu) =>
    items.map((item) => {
      const Wrapper = item.to ? Link : 'a';
      const props = item.to
        ? { to: item.to }
        : { href: item.href };
      return (
        <Wrapper
          key={item.key}
          {...props}
          className="dropdown-link"
          onClick={() => {
            closeMenu(false);
            navigate('/')
          }}
        >
          <span className="dropdown-icon">
            <FontAwesomeIcon icon={item.icon} />
          </span>
          <span className="dropdown-copy">
            <strong>{item.label}</strong>
            {item.description && <small>{item.description}</small>}
          </span>
        </Wrapper>
      );
    });

  const renderDropdownItems = () => (
    <>
      {userType === 'Teacher' && (
        <Link
          to={getProfileLink()}
          className="dropdown-link"
          onClick={() => setIsDropdownOpen(false)}
        >
          <span className="dropdown-icon">
            <FontAwesomeIcon icon={faUser} />
          </span>
          <span className="dropdown-copy">
            <strong>الملف الشخصي</strong>
            <small>حدث بياناتك وخبراتك بسهولة</small>
          </span>
        </Link>
      )}
      {(userType === 'superadmin' || userType === 'SuperAdmin') && (
        <Link
          to="/admin/dashboard"
          className="dropdown-link"
          onClick={() => setIsDropdownOpen(false)}
        >
          <span className="dropdown-icon">
            <FontAwesomeIcon icon={faDashboard} />
          </span>
          <span className="dropdown-copy">
            <strong>لوحة تحكم الأدمن</strong>
            <small>إدارة شاملة للمحتوى والمستخدمين</small>
          </span>
        </Link>
      )}
      {userType === 'Teacher' && (
        <Link
          to="/teacher/dashboard"
          className="dropdown-link"
          onClick={() => setIsDropdownOpen(false)}
        >
          <span className="dropdown-icon">
            <FontAwesomeIcon icon={faDashboard} />
          </span>
          <span className="dropdown-copy">
            <strong>لوحة المعلم</strong>
            <small>تتبع طلابك ودوراتك بسهولة</small>
          </span>
        </Link>
      )}
      {userType === 'User' && (
        <>
          <Link
            to="/mycourses"
            className="dropdown-link"
            onClick={() => setIsDropdownOpen(false)}
          >
            <span className="dropdown-icon">
              <FontAwesomeIcon icon={faBookOpen} />
            </span>
            <span className="dropdown-copy">
              <strong>دوراتي التعليمية</strong>
              <small>تابع ما تشاهده الآن</small>
            </span>
          </Link>
          <Link
            to="/myexam"
            className="dropdown-link"
            onClick={() => setIsDropdownOpen(false)}
          >
            <span className="dropdown-icon">
              <FontAwesomeIcon icon={faCheck} />
            </span>
            <span className="dropdown-copy">
              <strong>اختباراتي</strong>
              <small>نتائجك وتجاربك السابقة</small>
            </span>
          </Link>
          <Link
            to="/student-info"
            className="dropdown-link"
            onClick={() => setIsDropdownOpen(false)}
          >
            <span className="dropdown-icon">
              <FontAwesomeIcon icon={faUserGraduate} />
            </span>
            <span className="dropdown-copy">
              <strong>معلوماتي الشخصية</strong>
              <small>حدث بياناتك بسهولة</small>
            </span>
          </Link>
          <Link
            to="/mozakara"
            className="dropdown-link"
            onClick={() => setIsDropdownOpen(false)}
          >
            <span className="dropdown-icon">
              <FontAwesomeIcon icon={faBookOpen} />
            </span>
            <span className="dropdown-copy">
              <strong>المذكرات الدراسية</strong>
              <small>احصل على ملفات المذكرات والملخصات</small>
            </span>
          </Link>
        </>
      )}
      <Link
        to="/change-password"
        className="dropdown-link"
        onClick={() => setIsDropdownOpen(false)}
      >
        <span className="dropdown-icon">
          <FontAwesomeIcon icon={faLock} />
        </span>
        <span className="dropdown-copy">
          <strong>تغيير كلمة المرور</strong>
          <small>حافظ على أمان حسابك</small>
        </span>
      </Link>
    </>
  );

  return (
    <>
      {isMobile ? (
        <>
          <AppBar
            position="fixed"
            sx={{
              background: 'linear-gradient(120deg, rgba(122,106,216,0.92), rgba(122,106,216,0.92))',
              boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              borderBottom: '1px solid rgba(255,255,255,0.35)',
              borderBottomLeftRadius: 28,
              borderBottomRightRadius: 28,
              zIndex: 1300,
              fontFamily: cairoFont,
              '& *': { fontFamily: `${cairoFont} !important` },
              overflow: 'hidden'
            }}
            dir="rtl"
          >
            {/* <RamdanUI /> */}
            <Toolbar sx={{ position: 'relative', zIndex: 2, display: 'flex', justifyContent: 'space-between', minHeight: '64px', px: 2 }}>
              <IconButton edge="start" color="inherit" aria-label="menu" onClick={handleDrawerOpen}>
                <MenuIcon sx={{ fontSize: 30 }} />
              </IconButton>
              <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                <Box
                  component="img"
                  src={wordmarkSrc}
                  alt="شعار امتحاني"
                  sx={{ height: 30, objectFit: 'contain', filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.2))' }}
                />
                <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.88)', fontWeight: 600 }}>
                  مساحتك للتعلّم الذكي
                </Typography>
              </Box>
              {user ? (
                userImage ? (
                  <Avatar src={getFullFileUrl(userImage)} alt="User" sx={{ width: 40, height: 40, border: '2px solid rgba(255,255,255,0.6)', ml: 1 }} />
                ) : (
                  <Avatar sx={{ width: 40, height: 40, bgcolor: 'rgba(255,255,255,0.18)', color: '#fff', fontWeight: 700, ml: 1 }}>
                    {user[0]}
                  </Avatar>
                )
              ) : (
                <Button
                  component={Link}
                  to="/signin"
                  variant="contained"
                  sx={{
                    bgcolor: 'rgba(255,255,255,0.95)',
                    color: '#7a6ad8',
                    fontWeight: 800,
                    fontSize: '0.85rem',
                    px: 2,
                    py: 0.8,
                    borderRadius: 999,
                    boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                    '&:hover': {
                      bgcolor: '#fff',
                      transform: 'scale(1.05)',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                    },
                    transition: 'all 0.2s ease'
                  }}
                >
                  تسجيل الدخول
                </Button>
              )}
            </Toolbar>
          </AppBar>
          <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={handleDrawerClose}
            dir="rtl"
            sx={{ zIndex: 1400, fontFamily: cairoFont, '& *': { fontFamily: `${cairoFont} !important` } }}
          >
            <Box
              sx={{
                width: 290,
                pt: 2,
                px: 2.5,
                bgcolor: '#f8f9fa',
                height: '100vh',
                display: 'flex',
                flexDirection: 'column',
                overflowY: 'auto',
                fontFamily: cairoFont,
                '& *': { fontFamily: `${cairoFont} !important` }
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="h6" sx={{ color: '#7a6ad8', fontWeight: 900 }}>
                  لوحة التحكم
                </Typography>
                <IconButton onClick={handleDrawerClose}>
                  <CloseIcon sx={{ color: '#7a6ad8' }} />
                </IconButton>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  mb: 2,
                  p: 2,
                  borderRadius: 3,
                  background: 'linear-gradient(120deg, rgba(122,106,216,0.15), rgba(255,224,102,0.2))',
                  border: '1px solid rgba(122,106,216,0.2)'
                }}
              >
                {userImage ? (
                  <Avatar src={getFullFileUrl(userImage)} alt="User" sx={{ width: 54, height: 54, border: '2px solid #7a6ad8' }} />
                ) : (
                  <Avatar sx={{ width: 54, height: 54, bgcolor: '#7a6ad8', color: '#fff', fontWeight: 900 }}>
                    {user ? user[0] : <FontAwesomeIcon icon={faUser} />}
                  </Avatar>
                )}
                <Box>
                  <Typography sx={{ fontWeight: 800, color: '#1d1d1f', fontSize: '1.1rem' }}>{user || 'زائر'}</Typography>
                  <Typography sx={{ color: '#6b6b6b', fontSize: '0.9rem' }}>
                    {user ? 'سعداء بعودتك' : 'ابدأ رحلتك مع امتحاني'}
                  </Typography>
                </Box>
              </Box>
              <Divider sx={{ borderColor: 'rgba(122,106,216,0.2)', mb: 1.5 }} />
              <List sx={{ color: '#1d1d1f' }}>
                {[...homeMenuItems, ...servicesMenuItems, ...navQuickLinks].map((item) => (
                  <ListItem
                    button
                    key={item.key}
                    component={item.to ? Link : "a"}
                    {...(item.to ? { to: item.to } : { href: item.href })}
                    onClick={handleDrawerClose}
                    sx={{
                      borderRadius: 2,
                      mb: 0.5,
                      '&:hover': { bgcolor: 'rgba(122,106,216,0.08)' }
                    }}
                  >
                    <ListItemIcon sx={{ minWidth: 40, color: '#7a6ad8' }}>
                      <FontAwesomeIcon icon={item.icon} />
                    </ListItemIcon>
                    <ListItemText primary={item.label} primaryTypographyProps={{ fontWeight: 700 }} />
                  </ListItem>
                ))}
                {!user && (
                  <ListItem button component={Link} to="/signin" onClick={handleDrawerClose}>
                    <ListItemIcon sx={{ minWidth: 40, color: '#7a6ad8' }}>
                      <FontAwesomeIcon icon={faUserPlus} />
                    </ListItemIcon>
                    <ListItemText primary="تسجيل حساب جديد" primaryTypographyProps={{ fontWeight: 800 }} />
                  </ListItem>
                )}
              </List>
              <Box sx={{ flexGrow: 1 }} />
              <Divider sx={{ borderColor: 'rgba(122,106,216,0.2)', my: 2 }} />
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {userType === 'superadmin' || userType === 'SuperAdmin' ? (
                  <Button
                    variant="outlined"
                    component={Link}
                    to="/admin/dashboard"
                    onClick={handleDrawerClose}
                    startIcon={<FontAwesomeIcon icon={faDashboard} />}
                    sx={{ borderRadius: 3, fontWeight: 800, borderColor: '#7a6ad8', color: '#7a6ad8', gap: 1.5, justifyContent: 'center', '& .MuiButton-startIcon': { m: 0 } }}
                  >
                    لوحة تحكم الأدمن
                  </Button>
                ) : userType === 'Teacher' ? (
                  <Button
                    variant="outlined"
                    component={Link}
                    to="/teacher/dashboard"
                    onClick={handleDrawerClose}
                    startIcon={<FontAwesomeIcon icon={faDashboard} />}
                    sx={{ borderRadius: 3, fontWeight: 800, borderColor: '#7a6ad8', color: '#7a6ad8', gap: 1.5, justifyContent: 'center', '& .MuiButton-startIcon': { m: 0 } }}
                  >
                    لوحة المعلم
                  </Button>
                ) : user && userType === 'User' ? (
                  <>
                    <Button
                      variant="outlined"
                      component={Link}
                      to="/mycourses"
                      onClick={handleDrawerClose}
                      startIcon={<FontAwesomeIcon icon={faBookOpen} />}
                      sx={{ borderRadius: 3, fontWeight: 800, borderColor: '#7a6ad8', color: '#7a6ad8', gap: 1.5, justifyContent: 'center', '& .MuiButton-startIcon': { m: 0 } }}
                    >
                      دوراتي التعليمية
                    </Button>
                    <Button
                      variant="outlined"
                      component={Link}
                      to="/myexam"
                      onClick={handleDrawerClose}
                      startIcon={<FontAwesomeIcon icon={faCheck} />}
                      sx={{ borderRadius: 3, fontWeight: 800, borderColor: '#7a6ad8', color: '#7a6ad8', gap: 1.5, justifyContent: 'center', '& .MuiButton-startIcon': { m: 0 } }}
                    >
                      اختباراتي
                    </Button>
                    <Button
                      variant="outlined"
                      component={Link}
                      to="/student-info"
                      onClick={handleDrawerClose}
                      startIcon={<FontAwesomeIcon icon={faUserGraduate} />}
                      sx={{ borderRadius: 3, fontWeight: 800, borderColor: '#7a6ad8', color: '#7a6ad8', gap: 1.5, justifyContent: 'center', '& .MuiButton-startIcon': { m: 0 } }}
                    >
                      معلوماتي الشخصية
                    </Button>
                    <Button
                      variant="outlined"
                      component={Link}
                      to="/change-password"
                      onClick={handleDrawerClose}
                      startIcon={<FontAwesomeIcon icon={faLock} />}
                      sx={{ borderRadius: 3, fontWeight: 800, borderColor: '#7a6ad8', color: '#7a6ad8', gap: 1.5, justifyContent: 'center', '& .MuiButton-startIcon': { m: 0 } }}
                    >
                      تغيير كلمة المرور
                    </Button>
                  </>
                ) : null}
                {user ? (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={async () => {
                      setLogoutLoading(true);
                      try {
                        await handleLogout(navigate);
                      } finally {
                        setLogoutLoading(false);
                      }
                    }}
                    sx={{ borderRadius: 999, fontWeight: 800, py: 1.2, gap: 1.5, justifyContent: 'center' }}
                    disabled={logoutLoading}
                  >
                    {logoutLoading ? <span className="circle-loader" style={{ width: 18, height: 18 }} /> : 'تسجيل الخروج'}
                  </Button>
                ) : (
                  <Button
                    variant="contained"
                    component={Link}
                    to="/signin"
                    sx={{
                      borderRadius: 999,
                      fontWeight: 800,
                      background: 'linear-gradient(120deg, #7a6ad8, #ffe066)',
                      color: '#fff',
                      py: 1.2,
                      '&:hover': {
                        background: 'linear-gradient(120deg, #6a5ac8, #eed056)'
                      }
                    }}
                  >
                    تسجيل الدخول
                  </Button>
                )}
              </Box>
            </Box>
          </Drawer>
          <Box sx={{ height: '70px' }} />
        </>
      ) : (
        <motion.header
          ref={desktopHeaderRef}
          className="header-area header-sticky neo-header"
          initial={{ opacity: 0, y: -24 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
        >
          <motion.div className="header-glass-shell" dir="rtl" layout>
            {/* <RamdanUI /> */}
            <div className="logo-cluster">
              <Link to="/" className="logo-wordmark">
                <img src={wordmarkSrc} alt="شعار امتحاني" className="logo-wordmark-img" />
              </Link>
            </div>
            <nav className="main-nav enhanced-nav">
              <ul className="nav">
                <motion.li
                  className={`nav-item home-dropdown ${homeIsActive ? 'active' : ''}`}
                  ref={homeDropdownRef}
                  whileHover={{ y: -2 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <button
                    className="nav-pill"
                    aria-haspopup="true"
                    aria-expanded={isHomeDropdownOpen}
                    onClick={() => setIsHomeDropdownOpen((open) => !open)}
                  >
                    <span>الرئيسية</span>
                    <FontAwesomeIcon icon={isHomeDropdownOpen ? faChevronUp : faChevronDown} />
                  </button>
                  {isHomeDropdownOpen && (
                    <div className="dropdown-panel home-dropdown-menu">
                      {renderMenuContent(homeMenuItems, setIsHomeDropdownOpen)}
                    </div>
                  )}
                </motion.li>
                <motion.li
                  className={`nav-item services-dropdown ${homeActiveSections.slice(1).includes(activeSection) ? 'active' : ''}`}
                  ref={servicesDropdownRef}
                  whileHover={{ y: -2 }}
                  whileTap={{ scale: 0.98 }}
                >
                  <button
                    className="nav-pill"
                    aria-haspopup="true"
                    aria-expanded={isServicesDropdownOpen}
                    onClick={() => setIsServicesDropdownOpen((open) => !open)}
                  >
                    <span>الخدمات</span>
                    <FontAwesomeIcon icon={isServicesDropdownOpen ? faChevronUp : faChevronDown} />
                  </button>
                  {isServicesDropdownOpen && (
                    <div className="dropdown-panel services-dropdown-menu">
                      {renderMenuContent(servicesMenuItems, setIsServicesDropdownOpen)}
                    </div>
                  )}
                </motion.li>
                {navQuickLinks.map((item) => (
                  <motion.li
                    key={item.key}
                    className={`nav-item ${location.pathname === item.to ? 'active' : ''}`}
                    whileHover={{ y: -2 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <Link to={item.to} className="nav-pill">
                      <FontAwesomeIcon icon={item.icon} />
                      <span>{item.label}</span>
                    </Link>
                  </motion.li>
                ))}
                {!user && (
                  <motion.li
                    className="nav-item register-dropdown"
                    ref={registerDropdownRef}
                    whileHover={{ y: -2 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <button
                      className="nav-pill"
                      aria-haspopup="true"
                      aria-expanded={isRegisterDropdownOpen}
                      onClick={() => setIsRegisterDropdownOpen((open) => !open)}
                    >
                      <FontAwesomeIcon icon={faUserPlus} />
                      <span>تسجيل جديد</span>
                      <FontAwesomeIcon icon={isRegisterDropdownOpen ? faChevronUp : faChevronDown} />
                    </button>
                    {isRegisterDropdownOpen && (
                      <div className="dropdown-panel register-dropdown-menu">
                        {renderMenuContent(registerMenuItems, setIsRegisterDropdownOpen)}
                      </div>
                    )}
                  </motion.li>
                )}
              </ul>
            </nav>
            <div className="header-actions">
              {user ? (
                <div className="user-chip" ref={dropdownRef}>
                  <button
                    type="button"
                    onClick={() => setIsDropdownOpen((v) => !v)}
                    aria-haspopup="true"
                    aria-expanded={isDropdownOpen}
                  >
                    {userImage ? (
                      <img src={getFullFileUrl(userImage)} alt="User Avatar" className="user-chip-avatar" />
                    ) : (
                      <span className="user-chip-avatar placeholder">
                        <FontAwesomeIcon icon={faUser} />
                      </span>
                    )}
                    <span className="user-chip-name">{user}</span>
                    <FontAwesomeIcon icon={isDropdownOpen ? faChevronUp : faChevronDown} />
                  </button>
                  {isDropdownOpen && (
                    <div className="dropdown-panel user-dropdown-menu">
                      {renderDropdownItems()}
                      <button
                        className="dropdown-link logout-btn"
                        onClick={async () => {
                          setLogoutLoading(true);
                          try {
                            await handleLogout(navigate);
                          } finally {
                            setLogoutLoading(false);
                          }
                        }}
                        disabled={logoutLoading}
                      >
                        <span className="dropdown-icon">
                          {logoutLoading ? <span className="circle-loader" /> : <FontAwesomeIcon icon={faSignOutAlt} />}
                        </span>
                        <span className="dropdown-copy">
                          <strong>{logoutLoading ? 'جاري تسجيل الخروج...' : 'تسجيل الخروج'}</strong>
                          <small>نراك قريباً!</small>
                        </span>
                      </button>
                    </div>
                  )}
                </div>
              ) : (
                <Link to="/signin" className="login-link">
                  تسجيل الدخول
                </Link>
              )}
            </div>
          </motion.div>
        </motion.header>
      )}
      <style>{`
        /* ===== HEADER CONTAINER ===== */
        .header-area {
          position: fixed;
          top: 10px;
          left: 0;
          right: 0;
          z-index: 1200;
          padding: 0 18px;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }


        /* ===== HEADER SHELL - FULL WIDTH COVERAGE ===== */
        .header-glass-shell {
          position: relative;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: clamp(12px, 2vw, 24px);

          /* Full width coverage */
          width: 100%;
          max-width: 1180px;
          margin: 0 auto;
          padding: 10px 18px;
          box-sizing: border-box;

          background: rgba(255, 255, 255, 0.95);
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);
          backdrop-filter: blur(12px);
          transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .background-header .header-glass-shell {
          background: rgba(255, 255, 255, 0.98);
          border-color: #e5e7eb;
          box-shadow: 0 12px 28px rgba(15, 23, 42, 0.1);
        }

        /* ===== LOGO CLUSTER ===== */
        .logo-cluster {
          position: relative;
          z-index: 2;
          display: flex;
          flex-direction: column;
          gap: 4px;
          text-align: right;
          flex-shrink: 0;
        }

        .logo-wordmark {
          display: inline-flex;
          align-items: center;
          text-decoration: none;
          transition: transform 0.2s ease;
        }

        .logo-wordmark:hover {
          transform: scale(1.02);
        }

        .logo-wordmark-img {
          height: 34px;
          width: auto;
          display: block;
        }

        .logo-cluster p {
          margin: 0;
          color: rgba(255,255,255,0.88);
          font-size: clamp(0.8rem, 1.5vw, 0.95rem);
          font-weight: 600;
          white-space: nowrap;
        }

        /* ===== NAVIGATION ===== */
        .enhanced-nav {
          position: relative;
          z-index: 2;
          flex: 1;
          display: flex;
          justify-content: center;
        }

        .header-area .nav {
          display: flex;
          align-items: center;
          gap: clamp(6px, 1vw, 12px);
          list-style: none;
          padding: 0;
          margin: 0;
          flex-wrap: wrap;
        }

        .nav-item {
          position: relative;
        }

        .nav-pill {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          border: none;
          background: transparent;
          color: #111827;
          padding: 8px 12px;
          border-radius: 8px;
          font-weight: 700;
          font-size: 0.9rem;
          cursor: pointer;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          text-decoration: none;
          white-space: nowrap;
          box-shadow: none;
        }

        .nav-item.active .nav-pill,
        .nav-pill:hover {
          background: #f3f4f6;
          transform: none;
          box-shadow: none;
        }

        .nav-pill:active {
          transform: translateY(0);
        }

        /* ===== DROPDOWN PANEL ===== */
        .dropdown-panel {
          position: absolute;
          top: calc(100% + 12px);
          right: 0;
          padding: 18px;
          background: #fff;
          border-radius: 22px;
          min-width: 280px;
          max-width: 320px;
          display: flex;
          flex-direction: column;
          gap: 8px;
          box-shadow: 0 12px 48px rgba(0, 0, 0, 0.15);
          animation: fadeIn 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          z-index: 1300;
          border: 1px solid rgba(122, 106, 216, 0.1);
        }

        .user-dropdown-menu {
          width: 320px;
          right: auto;
          left: 0;
        }

        .dropdown-link {
          display: flex;
          align-items: flex-start;
          gap: 14px;
          padding: 12px;
          border-radius: 18px;
          text-decoration: none;
          background: rgba(122,106,216,0.06);
          color: #1d1d1f;
          font-weight: 700;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
          border: none;
          text-align: right;
          width: 100%;
          box-sizing: border-box;
          cursor: pointer;
        }

        .dropdown-link:hover {
          background: rgba(122,106,216,0.14);
          transform: translateX(-4px);
          box-shadow: 0 2px 8px rgba(122, 106, 216, 0.15);
        }

        .dropdown-link.logout-btn {
          color: #e53e3e;
          background: rgba(229,62,62,0.08);
        }

        .dropdown-link.logout-btn:hover {
          background: rgba(229,62,62,0.15);
          transform: translateX(-4px);
        }

        .dropdown-icon {
          width: 40px;
          height: 40px;
          min-width: 40px;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(122,106,216,0.12);
          color: #7a6ad8;
          font-size: 1.1rem;
        }

        .dropdown-copy {
          flex: 1;
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .dropdown-copy strong {
          display: block;
          font-size: 0.9rem;
          line-height: 1.3;
          color:black;
        }

        .dropdown-copy small {
          color: #6b6b6b;
          font-size: 0.8rem;
          font-weight: 600;
          line-height: 1.4;
        }

        .dropdown-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
              background: rgba(122, 106, 216, 0.06);
              border-radius: 18px;
        }

        .dropdown-group-trigger .dropdown-copy {
          flex: 1;
        }

        .dropdown-group-chevron {
          font-size: 0.85rem;
          color: #7a6ad8;
          flex-shrink: 0;
          align-self: center;
        }

        .dropdown-group-items {
          display: flex;
          flex-direction: column;
          gap: 8px;
          padding-right: 12px;
          border-right: 2px solid rgba(122, 106, 216, 0.15);
        }

        /* ===== HEADER ACTIONS ===== */
        .header-actions {
          position: relative;
          z-index: 2;
          display: flex;
          align-items: center;
          gap: clamp(8px, 1.5vw, 14px);
          flex-shrink: 0;
        }

        .cta-link {
          padding: 10px 14px;
          border-radius: 8px;
          background: #6366f1;
          color: #fff;
          font-weight: 800;
          font-size: 0.75rem;
          text-decoration: none;
          white-space: nowrap;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          box-shadow: none;
        }

        .cta-link:hover {
          transform: none;
          background: #0b1220;
        }

        .login-link {
          padding: 8px 10px;
          border-radius: 8px;
          border: 1px solid #d1d5db;
          color: #111827;
          text-decoration: none;
          font-weight: 700;
          font-size: 0.75rem;
          white-space: nowrap;
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .login-link:hover {
          background: #f3f4f6;
          border-color: #d1d5db;
        }

        /* ===== USER CHIP ===== */
        .user-chip {
          position: relative;
          display: inline-flex;
          align-items: center;
        }

        .user-chip button {
          border: none;
          background: #f3f4f6;
          border-radius: 10px;
          display: flex;
          align-items: center;
          gap: 10px;
          color: #111827;
          padding: 6px clamp(10px, 1.5vw, 16px);
          cursor: pointer;
          font-weight: 800;
          font-size: clamp(0.85rem, 1.2vw, 1rem);
          transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
          white-space: nowrap;
        }

        .user-chip button:hover {
          background: #e5e7eb;
        }

        .user-chip-avatar {
          width: 38px;
          height: 38px;
          min-width: 38px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid #e5e7eb;
        }

        .user-chip-avatar.placeholder {
          display: flex;
          align-items: center;
          justify-content: center;
          background: #d1d5db;
          color: #111827;
          font-size: 1rem;
        }

        .user-chip-name {
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        /* ===== LOADING SPINNER ===== */
        .circle-loader {
          display: inline-block;
          width: 18px;
          height: 18px;
          border: 3px solid rgba(255,255,255,0.3);
          border-top: 3px solid #7a6ad8;
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        /* ===== ANIMATIONS ===== */
        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-8px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        /* ===== RESPONSIVE BREAKPOINTS ===== */
        
        /* Large tablets and small desktops */
        @media (max-width: 1280px) {
          .header-glass-shell {
            max-width: 100%;
            padding: 16px 24px;
          }
        }

        /* Tablets */
        @media (max-width: 1024px) {
          .header-glass-shell {
            gap: 12px;
            padding: 14px 20px;
          }

          .nav-pill {
            padding: 8px 14px;
            font-size: 0.9rem;
          }

          .logo-wordmark-img {
            height: 65px;
          }
        }

        /* Hide desktop nav on mobile breakpoint */
        @media (max-width: 768px) {
          .header-area {
            display: none;
          }
        }
      `}</style>
    </>
  );
};

export default Header;
